module.exports = __webpack_public_path__ + "img/obradovic.6f73e728.jpg";